import { useState, useEffect, memo } from "react";
import AnalyticsDataTable from "../AnalyticsDataTable/AnalyticsDataTable";
import loading from "../../../assets/images/icons/loading.gif";
import B2BApi from "../../../B2bApiService";
import { Select } from "../../formComponents/Inputs";
import * as Constants from "../../../constants";
import TalentDetails from "../../talentsComponents/TalentDetails";
import { Dialog } from "primereact/dialog";
// import { useSelector } from "react-redux";
import { lookups, t } from "../../../content";
import { useLocale } from "../../../locale";
import { localizeColumns, localizeSelectOptions } from "../localizeAnalytics";

const CompetencePoints = (props) => {
  const { locale } = useLocale();
  // const definitions = useSelector(
  //   (state) => state?.contentfulAnalyticsData?.all["competencies"]
  // );
  // const scaleDescription = useSelector(
  //   (state) =>
  //     state.contentfulAnalyticsData.all["competencies"]?.scaleDescription
  // );
  const definitions = lookups.competencyTooltips;
  const scaleDescription = lookups.competencyScaleDescription;
  const [dataTableList, setDataTableList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [chartDialog, setChartDialog] = useState(false);
  const [showChartBtn, setShowChartBtn] = useState(false);
  const [allCol, setAllCol] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [columns, setColumns] = useState([]);
  const [rowData, setRowData] = useState();
  const [userDataDialog, setUserDataDialog] = useState(false);
  const { downloadDataUpdation, columnLabelUpdation } = props;
  let b2bObj = new B2BApi();

  useEffect(() => {
    if (props.tabActiveKey === Constants.TAB_COMPETENCIES_KEY) {
      getCompetencePoints();
    } else {
      setChartDialog(false);
    }
    // eslint-disable-next-line
  }, [props.tabActiveKey, props.selectedTeams]);

  useEffect(() => {
    if (userDataDialog === false) {
      setUserDataDialog(true);
    }
    // eslint-disable-next-line
  }, [rowData]);

  useEffect(() => {}, [userDataDialog]);

  useEffect(() => {
    if (allCol.length && selectedOption === "") {
      const firstGroup = allCol[0];
      setSelectedOption(firstGroup.group_name);
      setColumns([...firstGroup.columns_list]);
      if (columnLabelUpdation) {
        columnLabelUpdation(firstGroup.columns_list);
      }
    }
    // eslint-disable-next-line
  }, [allCol, selectedOption]);

  useEffect(() => {
    if (downloadDataUpdation) {
      downloadDataUpdation(dataTableList);
    }
    // eslint-disable-next-line
  }, [dataTableList]);

  useEffect(() => {
    if (showChartBtn === false) {
      if (downloadDataUpdation) {
        downloadDataUpdation(dataTableList);
      }
    }
    // eslint-disable-next-line
  }, [showChartBtn]);

  const getCompetencePoints = () => {
    let hash_list;
    if (props?.selectedTeams?.length > 0) {
      hash_list = props?.selectedTeams?.map((x) => x.hash);
    } else if (props?.allTeams?.length > 0) {
      hash_list = props?.allTeams?.map((x) => x.id);
    } else {
      hash_list = [];
    }

    b2bObj.GetCompetencePointsList(
      {
        company_id: "",
        hash_list: hash_list,
        is_user_pool: props.is_pool_list,
      },
      definitions,
      setDataTableList,
      setAllCol,
      setLoader,
      setSelectOptions
    );
  };

  const handleChange = (e) => {
    const val = e.target.value;
    const match = allCol.find((x) => x.group_name === val);
    if (match) {
      setSelectedOption(val);
      setColumns([...match.columns_list]);
    }
  };

  const selectedRow = (data) => {
    if (data) {
      if (downloadDataUpdation) {
        downloadDataUpdation(data);
      }
      setShowChartBtn(true);
    } else {
      setShowChartBtn(false);
    }
  };

  const onChartHide = () => {
    setChartDialog(false);
  };

  const onHide = () => {
    setUserDataDialog(false);
    setRowData();
  };

  return (
    <>
      {loader && !dataTableList ? (
        <div className="page-loading">
          <img src={loading} alt={t('common.labels.loading')} />
        </div>
      ) : (
        <div className="main-div">
          <Select
            key={locale}
            label={t('common.labels.groups')}
            option={selectedOption}
            options={localizeSelectOptions(selectOptions)}
            handleChange={handleChange}
            errorContent={t('validation.pleaseSelectGroup')}
          />
          <div className="dropdowns">
            {showChartBtn && (
              <button
                className="mazhrBtn default-green"
                onClick={() => setChartDialog(true)}
              >
                {t('analytics.showChart')}
              </button>
            )}
          </div>
          {dataTableList && props.tabActiveKey === Constants.TAB_COMPETENCIES_KEY && (
            <>
              {rowData && (
                <Dialog
                  style={{ width: "1000px" }}
                  visible={userDataDialog}
                  onHide={onHide}
                >
                  <TalentDetails
                    candidateId={rowData?.user_id}
                    asEmployee={!props.is_pool_list}
                  />
                </Dialog>
              )}
              <AnalyticsDataTable
                tabActiveKey={props.tabActiveKey}
                setRowData={setRowData}
                dataTableList={dataTableList}
                chartDialog={chartDialog}
                selectedRow={selectedRow}
                onChartHide={onChartHide}
                allCol={localizeColumns(columns)}
                scaleDescription={scaleDescription}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};
export default memo(CompetencePoints);
